/**
 * Dashboard API service
 * Handles HTTP requests to the dashboard endpoint
 */

import { api } from '@/lib/api';
import type { DashboardSummary } from '@/types/dashboard';

/**
 * Fetch the authenticated student's dashboard summary including profile, weekly stats, and daily pebbles
 * @returns Promise resolving to DashboardSummary object
 */
export async function getDashboardSummary(): Promise<DashboardSummary> {
  const response = await api.get<DashboardSummary>('/users/me/dashboard');
  return response.data;
}
